module.exports = __webpack_public_path__ + "img/yoshi.39d1ed47.png";